import React from 'react';
import { Button } from 'react-bootstrap';

interface Props {}

// Shown when the current-user request succeeds but returns no user,
// so the page never renders blank.
const UserNotLoaded: React.FC<Props> = () => (
  <div className="position-fixed h-100 w-100">
    <div className="p-4 h-100 d-flex flex-column justify-content-center align-items-center">
      <h4>
        <span>{`We couldn't load your Cyberportal account. If this keeps happening, please email `}</span>
        <a href={`mailto:${process.env.REACT_APP_EMAIL_SUPPORT_RECIPIENT}`}>us</a>
      </h4>
      <div>
        <Button className="mr-2" onClick={() => window.location.reload()}>
          Try Again
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('email');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('impersonate');
            window.location.href = process.env.REACT_APP_API_LOGIN_URL || '/';
          }}
        >
          Log In Again
        </Button>
      </div>
    </div>
  </div>
);

export default UserNotLoaded;
